export const getColoredIcon = (data: any) => {
    if (data.icon?.startsWith('<svg')) {
        return data.icon.replace(/<path\b([^>]*)>/g, (match, attrs) => {
            if (attrs.includes('fill=')) {
                return `<path${attrs.replace(/fill="[^"]*"/, `fill="${data.iconColor || '#4d575e'}"`)}>`;
            } else {
                return `<path${attrs} fill="${data.iconColor || '#4d575e'}">`;
            }
        });
    }
    return null;
};

